import { LocationOnOutlined, ManageAccounts, Moped, HandshakeOutlined } from '@mui/icons-material';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import { titlesNavigation } from 'config/configMessages';
import { ConsultPrivileges } from 'config/configRoutes';
import { getPrivileges } from "utils/generalUtils";
import { decryptStorage } from "utils/utils";
export const navigations = () => {
  const permisions = JSON.parse(decryptStorage(localStorage.getItem("dataUser")));
  let list = [];
  let operations = [];
  let otherProducts = [];
  let configurations = [];

  if (getPrivileges(permisions.role, ConsultPrivileges.proyTconsultPrivileges)) {
    operations.push({
      name: titlesNavigation.listProyt,
      path: "/dashboards",
      icon: AssignmentIndOutlinedIcon,
    });
  }
  if (getPrivileges(permisions.role, ConsultPrivileges.suscriberConsultPrivilege)) {
    operations.push({
      name: titlesNavigation.listSubscriber,
      path: "/clientSection",
      icon: PersonOutlineOutlinedIcon,
    });
  }
  if (getPrivileges(permisions.role, ConsultPrivileges.checkerConusltPrivilege)) {
    operations.push({
      name: titlesNavigation.listChecker,
      path: "/verificationSection",
      icon: FactCheckOutlinedIcon,
    });
  }
  if (getPrivileges(permisions.role, ConsultPrivileges.myselfConusltPrivilege)) {
    operations.push({
      name: titlesNavigation.listMyself,
      path: "/Myself",
      icon: BadgeOutlinedIcon,
    });
  }
  if (getPrivileges(permisions.role, ConsultPrivileges.logisticRoutes)) {
    operations.push({
      name: titlesNavigation.listSendLogistic,
      path: "/Logistica",
      icon: Moped,
    });
  }
  if (getPrivileges(permisions.role, ConsultPrivileges.supervisorConsult)) {
    operations.push({
      name: titlesNavigation.listAgreements,
      path: "/Convenios",
      icon: HandshakeOutlined,
    });
  }
  if (getPrivileges(permisions.role, ConsultPrivileges.consultElectronic)) {
    otherProducts.push({
      name: titlesNavigation.listElectronic,
      path: "/Electronics",
      icon: Inventory2OutlinedIcon,
    });

  }
  if (getPrivileges(permisions.role, ConsultPrivileges.otherProductsConsult)) {
    otherProducts.push({
      name: titlesNavigation.listApprovedAndRejected,
      path: "/RequestManagement",
      icon: BadgeOutlinedIcon,
    });
  }

  if (operations.length > 0) {
    list.push({
      type: "label",
      label: "Certificados digitales",
    });
    list = list.concat(operations);
  }

  if (otherProducts.length > 0) {
    list.push({
      type: "label",
      label: "Otros productos",
    });
    list = list.concat(otherProducts);
  }

  if (getPrivileges(permisions.role, ConsultPrivileges.consultRole) || getPrivileges(permisions.role, ConsultPrivileges.consultUser)) {

    const menuItem = {
      name: titlesNavigation.listRolesAndUsers,
      icon: ManageAccounts,
      children: []
    };

    if (getPrivileges(permisions.role, ConsultPrivileges.consultUser)) {
      menuItem.children.push({
        name: titlesNavigation.listUsers,
        path: "/Usuarios",
      });
    }
    if (getPrivileges(permisions.role, ConsultPrivileges.consultRole)) {
      menuItem.children.push({
        name: titlesNavigation.listRolesNavigation,
        path: "/Roles",
      });
    }
    configurations.push(menuItem)
  }

  if (getPrivileges(permisions.role, ConsultPrivileges.credentialsECD) && !getPrivileges(permisions.role, ConsultPrivileges.veriCredentialsECD)) {
    configurations.push({
      name: "Credenciales de certificado",
      path: "/credentials",
      icon: VpnKeyOutlinedIcon,
    });
  }
  if (getPrivileges(permisions.role, ConsultPrivileges.credentialsECD) && getPrivileges(permisions.role, ConsultPrivileges.veriCredentialsECD)) {
    configurations.push({
      name: "Credenciales de certificado",
      path: "/credentials",
      icon: VpnKeyOutlinedIcon,
    });
  }
  if (!getPrivileges(permisions.role, ConsultPrivileges.credentialsECD) && getPrivileges(permisions.role, ConsultPrivileges.veriCredentialsECD)) {
    configurations.push({
      name: "Credenciales de certificado",
      path: "/credentialsVerify",
      icon: VpnKeyOutlinedIcon,
    });
  }

  if (getPrivileges(permisions.role, ConsultPrivileges.consultConfig) || getPrivileges(permisions.role, ConsultPrivileges.modifyConfig)) {
    configurations.push({
      name: titlesNavigation.listSystemConfigurations,
      path: "/configurations",
      icon: SettingsIcon,
    });
  }

  if (getPrivileges(permisions.role, ConsultPrivileges.locationList)) {
    configurations.push({
      name: titlesNavigation.listUbications,
      path: "/Ubicaciones",
      icon: LocationOnOutlined,
    });
  }

  if (configurations.length > 0) {
    list.push({
      type: "label",
      label: titlesNavigation.listConfigurations,
    });
    list = list.concat(configurations);
  }

  return list;
};



